export default __webpack_public_path__ + "static/media/money.60edc4cf.svg";